import ApiService from "../api";

export default class SapServiceEntregaVolume extends ApiService {

    constructor() {
        super("/api/sap-entrega");
    }

    importar(data) {
        return this.post(`/upload`, data)
    }

    deletar(data) {
        return this.post(`/deletar`, data)
    }

    listarEntregas(filtro) {
        return this.post("/listar", filtro);
    }

    editar(data) {
        return this.put("", data);
    }

    listar() {
        const params = new URLSearchParams();
        return this.post(`?${params.toString()}`)
    }

    listarOperacoesPorPeriodo(dataInicio, dataFim) {
        return this.get(`/dias-operacao/periodo?inicio=${dataInicio}&fim=${dataFim}`);
    }

    lista(values) {
        const params = new URLSearchParams();

        params.append('ano', values.ano);
        params.append('mes', values.mes);
        params.append('comissoes', values.comissoes);

        if (values.filialId) params.append('filialId', values.filialId);

        return this.get(`?${params.toString()}`)
    }
}
